import React, { useState, useEffect, useRef } from 'react'
import ScrollAnimation from 'react-animate-on-scroll';
import Banner_1 from '../../static/banner_1.svg';
import Banner_2 from '../../static/banner_2.svg';
import Banner_3 from '../../static/banner_3.svg';
// import { useUser } from '../context/UserContext';

export default function Video() {
  
  return ( 
    <section id="banner" className="banner">
      <ScrollAnimation animateIn='bounceInLeft' animateOnce={true} >
      <div className="banner-header animate__animated animate__zoomIn">
        <h2>¿Cómo funciona Pulso?</h2>
        <span className="subtitle">
          Cuanto te registres la plataforma analizará tus intereses para mostrarte las causas que más relevantes
        </span>
      </div>
      </ScrollAnimation>
      <ScrollAnimation animateIn='bounceInUp' animateOnce={true} >
        <div className="banner-columns">
          <div className="banner-columns-column">
            <img src={Banner_1} alt=""/>
            <p>
              En Pulso personas de todo el mundo 
              inician campañas, movilizan a otros 
              ciudadanos y colaboran para promover 
              soluciones.
            </p>
          </div>
          <div className="banner-columns-column">
            <img src={Banner_2} alt=""/>
            <p>
              Amplificá tu mensaje con un Pulso 
              interesante que sea escuchado 
              por periodistas y otros marcadores 
              de agenda.
            </p>
          </div>
          <div className="banner-columns-column">
            <img src={Banner_3} alt=""/>
            <p>
              Las personas atraviesan fronteras 
              geográficas y culturales para vincularse 
              y apoyar pulsos que les importan.
            </p>
          </div>
        </div>
      </ScrollAnimation>
    </section>
  )
}